import React from "react";

const SlackIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.58962 24.758C9.58962 26.8503 7.89989 28.5414 5.80921 28.5414C3.71854 28.5414 2.02881 26.8503 2.02881 24.758C2.02881 22.6656 3.71854 20.9745 5.80921 20.9745H9.58962V24.758ZM11.4798 24.758C11.4798 22.6656 13.1696 20.9745 15.2602 20.9745C17.3509 20.9745 19.0406 22.6656 19.0406 24.758V34.2166C19.0406 36.3089 17.3509 38 15.2602 38C13.1696 38 11.4798 36.3089 11.4798 34.2166V24.758Z",
  fill: "#E01E5A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.2601 9.56688C13.1694 9.56688 11.4797 7.8758 11.4797 5.78344C11.4797 3.69108 13.1694 2 15.2601 2C17.3507 2 19.0405 3.69108 19.0405 5.78344V9.56688H15.2601ZM15.2601 11.4873C17.3507 11.4873 19.0405 13.1783 19.0405 15.2707C19.0405 17.3631 17.3507 19.0541 15.2601 19.0541H5.78041C3.68973 19.0541 2 17.3631 2 15.2707C2 13.1783 3.68973 11.4873 5.78041 11.4873H15.2601Z",
  fill: "#36C5F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.4105 15.2707C30.4105 13.1783 32.1002 11.4873 34.1909 11.4873C36.2816 11.4873 37.9713 13.1783 37.9713 15.2707C37.9713 17.3631 36.2816 19.0541 34.1909 19.0541H30.4105V15.2707ZM28.5203 15.2707C28.5203 17.3631 26.8306 19.0541 24.7399 19.0541C22.6492 19.0541 20.9595 17.3631 20.9595 15.2707V5.78344C20.9595 3.69108 22.6492 2 24.7399 2C26.8306 2 28.5203 3.69108 28.5203 5.78344V15.2707Z",
  fill: "#2EB67D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.7399 30.4331C26.8306 30.4331 28.5203 32.1242 28.5203 34.2166C28.5203 36.3089 26.8306 38 24.7399 38C22.6492 38 20.9595 36.3089 20.9595 34.2166V30.4331H24.7399ZM24.7399 28.5414C22.6492 28.5414 20.9595 26.8503 20.9595 24.758C20.9595 22.6656 22.6492 20.9745 24.7399 20.9745H34.2195C36.3102 20.9745 37.9999 22.6656 37.9999 24.758C37.9999 26.8503 36.3102 28.5414 34.2195 28.5414H24.7399Z",
  fill: "#ECB22E"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SlackIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;